module.exports = __webpack_public_path__ + "static/img/coupon.27003666.png";